<template>
	<v-card 
		flat
		color="secondary"
		class="estates-container"
		dark
		height="100%"
	>
		<v-card-title 
			primary class="title"
			height="100%"
		>
			List Assets
		</v-card-title>

		<v-card 
			flat
			color="secondary"
			class="estates-container-none"
			dark
			height="71%"
		>
			<agile
				v-if="estates.length"
				:dots="false"
				:slides-to-show="4"
				:infinite="false"
				class="carousel"
				
			>
				<!-- <v-spacer class="carousel-spacer" /> -->
				<v-flex
					v-for="(estate, index) in estates"
					:key="index"
					class="carousel-items-container"
					
				> 
					<div class="carousel-item">
						
						<img
							:src="estate.photos ? estate.photos[0] : require('../assets/estate-placeholder.jpg')" 
							class="img-button"
							height="120px"
							@click="selectCurrentEstate (estate)"
						>
							
					</div>
				</v-flex>
		
				<template slot="prevButton">
					<div class="prev-container">
						<v-icon color="white">
							fas fa-arrow-left
						</v-icon>
					</div>
				</template>
				<template slot="nextButton">
					<div class="next-container">
						<v-icon
							color="white"
						>
							fas fa-arrow-right
						</v-icon>
					</div>
				</template>
			</agile>

			<v-container v-else grid-list-xs 
				class="carousel"
			>
				<v-layout 
					column 
					wrap 
					alig-center
					justify-center
				>
					<v-icon size="50">
						fas fa-sad-tear
					</v-icon>
					<v-spacer />
					<h1 style="text-align: center;">
						There are no Estates in this area.
					</h1>
				</v-layout>
			</v-container>
		</v-card>
	</v-card>	
</template>

<script>
import { VueAgile } from 'vue-agile'
import { mapMutations } from 'vuex'

export default {
	components: { agile: VueAgile },
	props: ['estates'],
	data () {
		return {
			
		}
	},
	computed: {

	},

	watch: {
		
	},
	
	created: function () {
	},

	methods: {
		...mapMutations (['selectEstate']),

		selectCurrentEstate (estate) {
			this.selectEstate (estate)
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';

.estates-container {
	border: 1px solid white !important;
}

.estates-container-none {
	border: 0px solid white !important;
}

.carousel {
	height: 100% !important; 
	display:flex; 
	align-items: center;
}

.carousel-spacer {
	margin-left: -3%;
}

.carousel-items-container {
	height: 100%; 
	display:flex;
	justify-content: center; 
}

.carousel-item {
	display: flex; 
	justify-content: center; 
	align-items: center; 
	height: 100%; 
	width: 100% !important;
	max-width: 250px;
}

.overflow-hidden {
  overflow: hidden;
}
.horiz-scroll {
  overflow-y: hidden;
  overflow-x: auto;
}

.img-button {
	cursor: pointer;
	border: 2px solid $secondary !important; 
  transition: border .3s;

	&:hover {
		border: 1px solid white !important; 
	}
}


.prev-container {
	position: absolute;
	left: 0px;
	top: 0px;
	height: 100%;
	width: 5%;
	background: rgba($color: $secondary, $alpha: 1);
	display:flex;
  justify-content: center; 
  align-items: center;
	z-index: 2;
}
.next-container {
	position: absolute;
	right: 0px;
	top: 0px;
	height: 100%;
	width: 5%;
	background: rgba($color: $secondary, $alpha: 1);
	display:flex;
  justify-content: center; 
  align-items: center;
	z-index: 2;
}
</style>